import { Box, Text } from '@chakra-ui/react'
import { fetcherNewsRoom, NewsEndpoints } from '@olagg/api-hooks'
import { parseDate } from '@olagg/ui-kit'
import { useCallback, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ROUTES } from '../../../routes'
import { useNrTranslation } from '@/utils/useNrTranslation';
import i18n from 'i18next';

const RelatedNews = ({ relatedNews = [], tags = [], title = i18n.t('News.single.relatedNews.title') }) => {
  const { tNr } = useNrTranslation();
  const [news, setNews] = useState([]);
  const [notFound, setNotFound] = useState(false);
  
  const initRequest = useCallback(async () => {
    await fetcherNewsRoom(
      NewsEndpoints.byTag(tags)
    ).then((response: Array<any>) => {
      setNews(response);
      setNotFound(false)
    }).catch(e => {
      setNotFound(true)
    })
  }, [])

  useEffect(() => {
    if (relatedNews.length) {
      setNews(relatedNews);
    } else {
      initRequest();
    }
  }, [])

  if (notFound) {
    return (<></>)
  }

  return (
    <>
      {news.length > 0 && (
        <Box>
          <Text fontSize='23px'>{title}</Text>
          <Box my='5'>
            {news.map((n, index) => {
              if (index < 5) {
                return (
                  <Box
                    key={index}
                    mt='3'
                    pb='1'
                    borderBottom='1px solid #343847'
                  >
                    <Link to={`${ROUTES.NEWS}/${n.slug}`}>
                      {tNr('title', n)} | {parseDate(n.publicationDate)}
                    </Link>
                  </Box>
                )
              }
            })}
          </Box>
        </Box>
      )}
    </>
  )
}

export default RelatedNews
